import request from '@/utils/request'

export function getList(data) {
  return request({
    url: 'api/work/v1/list',
    method: 'post',
    data
  })
}
export function deleteWork(data) {
  return request({
    url: 'api/work/v1/delete',
    method: 'post',
    data
  })
}
export function save(data) {
  return request({
    url: 'api/work/v1/delivery',
    method: 'post',
    data
  })
}
export function authFile(data) {
  return request({
    url: 'api/agent/v1/authFile',
    method: 'post',
    data
  })
}
export function viewWork(data) {
  return request({
    url: 'api/work/v1/detail',
    method: 'post',
    data
  })
}
export function exportWork(data,competition_id) {
  return request({
    url: 'api/agent/v1/export/'+data+'?competition_id='+competition_id,
    method: 'get'
  })
}

/**
 * 个人用户作品列表
 */
export function getMyWorks(data) {
  return request({
    url: 'api/mywork/v1/list',
    method: 'post',
    data
  })
}

/**
 * 个人用户作品详情
 */
export function viewMyWork(data) {
  return request({
    url: 'api/mywork/v1/detail',
    method: 'post',
    data
  })
}

/**
 * 个人用户提交/编辑作品
 */
export function saveMyWork(data) {
  return request({
    url: 'api/mywork/v1/delivery',
    method: 'post',
    data
  })
}